module.exports = __webpack_public_path__ + "static/img/far3.9af1f3b9.png";